import { render, staticRenderFns } from "./ReportEditor.vue?vue&type=template&id=51a20f50"
import script from "./ReportEditor.vue?vue&type=script&lang=js"
export * from "./ReportEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports